/* eslint-disable jsx-a11y/anchor-is-valid,no-script-url */
import * as React from "react";
import {
  Settings,
  useHasPermission,
  AppPermissions,
  State,
} from "../../../core";
import { TabNames } from "../props";
import classnames from "classnames";
import { useSelector } from "react-redux";

export interface CustomProps {
  tabName: TabNames;
  tabChangeHandler: (tabName: TabNames) => void;
  onlineLeadCompleted?: boolean;
  ownerEntitiesCompleted?: boolean;
}

const LeftMenu: React.FunctionComponent<CustomProps> = (props) => {
  const authState = useSelector((state: State) => state.authUser);
  const [tabName, setTabName] = React.useState<TabNames>(
    props.tabName || TabNames.VisibilityGroups
  );
  const setElementActive = (tabValue: TabNames) => {
    setTabName(tabValue);
    props.tabChangeHandler(tabValue);
  };

  const canViewVisiblityGroup =
    authState.apiPermissions?.[AppPermissions.ViewVisiblityGroup];

  const canViewRoles = authState.apiPermissions?.[AppPermissions.ViewRoles];

  return (
    <div className="col-xl col-lg-3 col-12 bg-gray-100 border-right px-2 py-4 lead-settings-menu">
      <ul className="list-unstyled mb-0 px-0 font-normal font-weight-semibold position-relative lead-settings-list">
        <li>
          <a
            href="javascript:void(0)"
            className={`px-2 py-2 d-flex align-items-center rounded ${
              tabName === TabNames.OwnerUnassignedEntities ? "active" : ""
            }`}
            onClick={(e) => setElementActive(TabNames.OwnerUnassignedEntities)}
          >
            <span className="col py-1 d-block">
              Proposal Cover Image
              <span></span>
            </span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default LeftMenu;
